export default __webpack_public_path__ + "static/media/layout_1.8b690fec.png";